import { FigmaIntegrationCard } from '../components/settings/FigmaIntegrationCard';
import { JiraIntegrationCard } from '../components/settings/JiraIntegrationCard';
import { LinearIntegrationCard } from '../components/settings/LinearIntegrationCard';
import { NotionIntegrationCard } from '../components/settings/NotionIntegrationCard';
import { AsanaIntegrationCard } from '../components/settings/AsanaIntegrationCard';
import { TrelloIntegrationCard } from '../components/settings/TrelloIntegrationCard';
import { SlackIntegrationCard } from '../components/settings/SlackIntegrationCard';
import { AiToolIntegrationCards } from '../components/settings/AiToolIntegrationCards';
import { AutomationIntegrations } from '../components/settings/AutomationIntegrations';

export function IntegrationsPage() {
  return (
    <section id="integrations" className="page-content">
      <div className="page-content__inner page-content__inner--app mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <FigmaIntegrationCard />
          <JiraIntegrationCard />
          <LinearIntegrationCard />
          <NotionIntegrationCard />
          <AsanaIntegrationCard />
          <AsanaIntegrationCard provider="clickup" />
          <AsanaIntegrationCard provider="github" />
          <AsanaIntegrationCard provider="basecamp" />
          <AsanaIntegrationCard provider="monday" />
          <TrelloIntegrationCard />
          <SlackIntegrationCard />
          <AiToolIntegrationCards />
          <AutomationIntegrations />
        </div>
      </div>
    </section>
  );
}
